/**
 * Les gestes des trois écrans de lecture du jeu : « Mes quêtes », le détail d'une quête et
 * « Classement ».
 *
 * La croix des anciens écrans (`MySkillSetsTabScreen.js`, `RankingTabScreen.js`) : retour, ou le menu
 * quand la pile est vide. Une quête s'ouvre comme avant : `skill-sets` avec son identifiant. La
 * flèche du détail (`MyProgressScreen.js`) : retour, avec le même repli. Le classement ouvert sur un
 * téléphone est un état d'interface : l'onglet d'aujourd'hui, devenu une pilule.
 */
import { useNavigation } from "@react-navigation/native"
import { useReducer } from "react"

import { useBackOr } from "../../../hooks/useBackOr"

import { type UIQuest } from "../../../types/studentGame"

type PushNavigation = { push: (route: string, params?: object) => void }

export function useStudentQuestsState() {
    const navigation = useNavigation() as unknown as PushNavigation
    const leave = useBackOr("menu")
    return {
        onClose: leave,
        onOpenQuest: (quest: UIQuest) => navigation.push("skill-sets", { skillSetId: quest.id }),
    }
}

export function useStudentQuestDetailState() {
    return { onBack: useBackOr("menu") }
}

/** Le classement choisi : la clé de sa pilule. `null` : le premier. */
const selectBoardReducer = (_state: string | null, key: string): string | null => key

export function useStudentRankingState() {
    const leave = useBackOr("menu")
    const [activeKey, selectBoard] = useReducer(selectBoardReducer, null)
    return { onClose: leave, activeKey: activeKey ?? undefined, onSelectBoard: selectBoard }
}
